<div class="page-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <div class="badge-trophy">
        <mat-icon>emoji_events</mat-icon>
        <span>Global Rankings</span>
      </div>
      <h1 class="page-title">Leaderboard Rankings</h1>
      <p class="page-subtitle">Track high scores, punch records, and competitive athlete rankings</p>
    </div>
  </div>

  <mat-card class="content-card">
    <mat-card-content class="p-0">
      <!-- Toolbar -->
      <div class="table-toolbar">
        <div class="search-box">
          <mat-form-field appearance="outline" class="w-100 search-field" subscriptSizing="dynamic">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput placeholder="Search by username..." [(ngModel)]="searchItem" (input)="search($event)" />
          </mat-form-field>
        </div>

        <!-- Duration Filter Pills -->
        <div class="duration-filters">
          <button mat-stroked-button (click)="getLeaderBoardByDuration('')" class="duration-btn">
            All Durations
          </button>
          <button mat-stroked-button (click)="getLeaderBoardByDuration('30')" class="duration-btn">
            30s Round
          </button>
          <button mat-stroked-button (click)="getLeaderBoardByDuration('50')" class="duration-btn">
            50s Round
          </button>
          <button mat-stroked-button (click)="getLeaderBoardByDuration('70')" class="duration-btn">
            70s Round
          </button>
        </div>
      </div>

      <!-- Data Table -->
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="leaderboard-table">
          <!-- Rank Column -->
          <ng-container matColumnDef="rank">
            <th mat-header-cell *matHeaderCellDef class="rank-header"> Rank </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <div class="rank-badge" [ngClass]="{
                'gold': element.rank === 1 || i === 0,
                'silver': element.rank === 2 || i === 1,
                'bronze': element.rank === 3 || i === 2
              }">
                <mat-icon *ngIf="element.rank === 1 || i === 0">workspace_premium</mat-icon>
                <span>#{{ element.rank || (i + 1) }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Athlete / Title Column -->
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Athlete / Title </th>
            <td mat-cell *matCellDef="let element">
              <div class="athlete-cell">
                <div class="athlete-avatar">
                  <img *ngIf="element.profileImage" [src]="element.profileImage" alt="" />
                  <img *ngIf="!element.profileImage" src="assets/images/logos/brand-logo.png" alt="Logo" class="avatar-logo" />
                </div>
                <div class="athlete-info">
                  <span class="athlete-name">{{ element.name || element.user?.fullName || 'Boxing Athlete' }}</span>
                  <span class="athlete-sub">
                    {{ element.title }}<span *ngIf="element.duration"> &middot; {{ element.duration }}s Round</span>
                  </span>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Country Column -->
          <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef> Country </th>
            <td mat-cell *matCellDef="let element">
              <span class="country-chip">{{ element.country || 'Unknown' }}</span>
            </td>
          </ng-container>

          <!-- Punches Column -->
          <ng-container matColumnDef="punchCount">
            <th mat-header-cell *matHeaderCellDef> Total Punches </th>
            <td mat-cell *matCellDef="let element">
              <div class="punch-score-chip">
                <mat-icon>bolt</mat-icon>
                <strong>{{ element.punchCount || element.totalPunches || 0 }}</strong>
                <span>punches</span>
              </div>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Verified Status </th>
            <td mat-cell *matCellDef="let element">
              <span class="status-badge active">
                <span class="dot"></span>
                Verified Score
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
        </table>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="dataSource?.length === 0 || dataSource?.data?.length === 0">
        <mat-icon>emoji_events</mat-icon>
        <h3>No Rankings Recorded</h3>
        <p>No leaderboard records found for the selected round duration.</p>
      </div>

      <!-- Paginator -->
      <mat-paginator
        #paginator
        [length]="totalCount"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 50]"
        (page)="onPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>